function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "presets_svg__cls-3",
  d: "M106.42 44.54H26.11a2.5 2.5 0 010-5h80.31a2.5 2.5 0 010 5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "presets_svg__cls-3",
  d: "M41 47.92V34.61a2.5 2.5 0 015 0v13.31a2.5 2.5 0 01-5 0zM87 73.92V60.61a2.5 2.5 0 015 0v13.31a2.5 2.5 0 01-5 0zM63 97.92V84.61a2.5 2.5 0 015 0v13.31a2.5 2.5 0 01-5 0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "presets_svg__cls-3",
  d: "M106.42 69.54H26.11a2.5 2.5 0 010-5h80.31a2.5 2.5 0 010 5zM106.42 94.54H26.11a2.5 2.5 0 010-5h80.31a2.5 2.5 0 010 5z"
});

function SvgPresets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "presets_svg__Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgPresets;